import React from "react";

const Footer = () => {
  return (
    <footer
      className="
      py-6 text-center
      bg-white dark:bg-gray-900
      border-t border-gray-200 dark:border-gray-800
      transition-colors duration-300"
    >
      <p className="text-gray-600 dark:text-gray-400 text-sm">
        © {new Date().getFullYear()} Harshal Aglawe.<br className="block md:hidden"/> Crafted with code and coffee ☕
      </p>
    </footer>
  );
};

export default Footer;
